var s = {};
export {
  s as __exports
};
//# sourceMappingURL=index.es484.js.map
